import Vue from "vue";
import VueMq from "vue-mq";

Vue.use(VueMq, {
  breakpoints: {
    xs: -1,
    sm: 600,
    md: 600,
    lg: Infinity,
  },
  defaultBreakpoint: "sm",
});
